import { Unregistered } from "@/pages/Unregistered";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/unregistered")({
  validateSearch: (
    search: Record<string, unknown>
  ): { code?: string; error?: string } => {
    return {
      code: search.code as string | undefined,
      error: search.error as string | undefined,
    };
  },
  component: Unregistered,
});
